import classnames from "classnames";
import React from "react";
import { IPrimary } from "src/types/prismic";
import styled from "styled-components";

import EmbedYoutube from "./components/YoutubePlayer";

interface IWrapper {
  ratio: string;
}

const Wrapper = styled.div<IWrapper>`
  position: relative;

  & > div {
    position: relative;
    height: 0;
    width: 100%;
    padding-bottom: ${({ ratio }: IWrapper): string | undefined =>
      ratio === "21/9" ? "42.8571%" : ratio === "16/9" ? "56.25%" : undefined};
  }
`;

interface IProps {
  data: IPrimary;
}

const EmbedVideo = ({ data }: IProps): JSX.Element | null => {
  const {
    video_id,
    video_platform,
    video_ratio,
    classnames: videoClassnames,
    video_poster,
  } = data;

  if (video_platform === "Youtube") {
    if (!(video_id && video_ratio)) {
      return null;
    }

    return (
      <Wrapper
        className={classnames("video-player", videoClassnames)}
        ratio={video_ratio}
      >
        <EmbedYoutube videoId={video_id} poster={video_poster} />
      </Wrapper>
    );
  } else {
    return null;
  }
};

export default EmbedVideo;
